var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("app-resumo-cadastrante", {
                attrs: {
                  cadastrante: _vm.cadastro.cadastrante,
                  isProcessoFisico: true
                }
              }),
              _c("app-resumo-interessado", {
                attrs: {
                  interessado: _vm.cadastro.interessado,
                  hasConjuge: true,
                  idCadastro: _vm.idCadastro,
                  isLiberacao: false,
                  isProcessoFisico: true
                }
              }),
              _vm.cadastro
                ? _c("resumo-imovel", {
                    attrs: {
                      imovel: _vm.cadastro.imovel,
                      idCadastro: _vm.idCadastro,
                      hasFieldsExtras: false,
                      isProcessoFisico: true
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d13cae2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d13cae2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/maranhao/processoFisico/components/Resumo.vue
// module id = null
// module chunks = 